import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout from "./PolicyLayout";

function Privacy() {
  return (
    <PolicyLayout
      title="Privacy policy"
      intro="This notice explains the information handled while you browse, keep a cart, begin checkout, pay through the hosted payment page, or contact mavormira."
    >
      <section>
        <h2>Information and its source</h2>
        <ul>
          <li><strong>Cart choices:</strong> product identifiers, selected options and quantities that you place in the cart.</li>
          <li><strong>Checkout details:</strong> email, delivery country or region, recipient name, street address, city and postal code that you type into checkout.</li>
          <li><strong>Payment-session details:</strong> order number, amount, currency, first product title and the success or cancellation return address used to create the hosted session.</li>
          <li><strong>Support correspondence:</strong> the sender, subject and message that you choose to pass to your email application from the contact page.</li>
        </ul>
        <p>Payment credentials are entered on Stripe's hosted checkout page and are handled under the notice presented in that environment.</p>
      </section>

      <section>
        <h2>How each item is used</h2>
        <p>Cart choices preserve the basket and calculate totals. Checkout and payment-session details validate the shopping step, create the requested payment session, associate it with the correct amount, and return the browser to the appropriate result page. Support correspondence is used to answer the question, identify an order when supplied, and keep a record within the participating email services.</p>
        <p>Information is not repurposed in a way incompatible with the reason it was provided without first giving an updated notice and obtaining any consent required by law.</p>
      </section>

      <section>
        <h2>Storage and transfers in this shopping flow</h2>
        <p>The cart remains in the browser's local storage until products are removed or that storage is cleared. Checkout fields remain in the active page state. The payment start sends the email and payment-session details to the same-origin PHP endpoint, which requests the hosted Stripe session. The current payment parameter contract does not transmit the recipient and street-address fields.</p>
        <p>Selecting the email contact action hands the composed content to the visitor's chosen email application. Email providers and Stripe process information under their own retention, security and cross-border arrangements. Cart storage is controlled on the visitor's device; active page fields end when that page state is discarded.</p>
      </section>

      <section>
        <h2>Protection and data minimisation</h2>
        <p>The storefront separates payment credentials from its React forms and uses a server endpoint to create the hosted payment session. Customers should not place card credentials, identity documents, health details or unrelated information in support email. Internet transmission and personal devices carry unavoidable risks, so suspicious payment or account messages should not be followed; contact support through the address published on this site.</p>
      </section>

      <section>
        <h2>Access, correction and privacy questions</h2>
        <p>Requests concerning personal data are handled through the process in our <Link to="/data-rights">Consumer data rights policy</Link>. State the information involved and the interaction or order that will help locate it. Identity may be verified using information proportionate to the request.</p>
        <p>This notice works with the <Link to="/cookies">cookie and browser storage notice</Link>. Mandatory privacy rights remain available even where this notice is silent.</p>
      </section>
    </PolicyLayout>
  );
}

export default Privacy;
